import { EnterpriseOnboardingFlow } from "../components/EnterpriseOnboardingFlow";

export function EnterpriseOnboardingPage({ onComplete, onLogout, onOrgSetupComplete }) {
  return <EnterpriseOnboardingFlow onComplete={onComplete} onLogout={onLogout} onOrgSetupComplete={onOrgSetupComplete} />;
}

export default EnterpriseOnboardingPage;
